// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Components/Auth/Login';
import Dashboard from './Components/Dashboard/Dashboard';
import Layout from './Components/Layout';
import DocMasterListView from './Components/DocMas/DocMasterView';
import ReportView from './Components/Report/ReportView';
import DrReportView from './Components/DrReport/Drreportview';
import PrintScreen from './Components/Print/PrintScreen';
import UserManagement from './Components/User/userManagement';
import LocationView from './Components/Location/Location';
import { HistoryProvider } from './Components/Breadcrum/HistoryProvider';

function App() {
  return (
    <>
      <Router>
        <HistoryProvider>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Layout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="doc-master-list" element={<DocMasterListView />} />
              <Route path="report" element={<ReportView />} />
              <Route path="print" element={<PrintScreen />} />
              <Route path="user_management" element={<UserManagement />} />
              <Route path="location" element={<LocationView />} />
              <Route path="dr-reports" element={<DrReportView />} />
            </Route>
          </Routes>
        </HistoryProvider>
      </Router>
    </>
  );
}

export default App;